import { IPagination } from '../app-configuration';

export * from './history-mapper'
export * from './history-configuration'
export * from './property-history-response.model';
export * from './property-history-parameter.model';
export * from './demand-history-response.model';
export * from './demand-history-parameter.model';
export * from './person-history-response.model';
export * from './person-history-parameter.model';
export * from './agenda-history-response.model';
export * from './agenda-history-parameter.model';
export * from './task-history-response.model';
export * from './task-history-parameter.model';

// @ts-ignore
export interface IHistoryResponse<T, TP> {
  listOfItems: T[];
  loading?: boolean;
  pagination?: IPagination,
  Ids?: number[]
}

export class HistoryResponse<T, TP> implements IHistoryResponse<T, TP> {
  listOfItems: T[];
  loading?: boolean;
  pagination?: IPagination
  Ids?: number[]
  /**
   *
   */
  constructor(opt: IHistoryResponse<T, TP>) {
    this.listOfItems = opt.listOfItems;
    this.loading = opt.loading;
    this.pagination = opt.pagination;
    this.Ids = opt.Ids;
  }
}